import React, { useEffect, useState } from 'react';
import { CButton, CModal, CModalBody, CModalHeader } from '@coreui/react';
import { ApplicationState } from 'src/store';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
interface IProps {
  showModal: boolean;
  message: string;
  onClose: () => void;
}

const BlockedModal: React.FC<IProps> = ({ showModal, message, onClose }) => {
  const state_lang = useSelector((state: ApplicationState) => state.lang);
  const [t, i18n] = useTranslation();
  const [lang, setLang] = useState(state_lang);
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);
  useEffect(() => {
    setLang(state_lang);
  }, [state_lang]);
  return (
    <>
      <CModal
        show={showModal}
        backdrop={true}
        closeOnBackdrop={false}
        className="dialog-success-modal"
        onClose={onClose}
      >
        <CModalHeader closeButton></CModalHeader>
        <CModalBody>
          <h6 className=" font-weight-bold mb-4 text-white-dark-theme">{t(message)}</h6>

          <div className="w-100  d-flex justify-content-center">
            <CButton
              color="secondary"
              shape="square"
              size="sm"
              className="m-1 px-3 rounded-lg  "
              onClick={() => onClose()}
              style={{ width: '100px' }}
            >
              {t('閉じる')}
            </CButton>
          </div>
        </CModalBody>
      </CModal>
    </>
  );
};

export default BlockedModal;
